import { Variant } from '../../../Variant/Variant';
import styles from './ClassicQuiz.module.css';
import { motion } from 'motion/react';

export const ClassicQuiz = ({ variants, isStateCorrectVar, initDelay }) => {
  return (
    <motion.div className={styles.variantsContainer}>
      {variants?.map((item, i) => (
        <motion.div
          key={item.coment + String(i)}
          initial={{
            scale: 0,
            originX: 0,
            originY: 'center',
          }}
          animate={{
            scale: 1,
            originX: 0,
            originY: 'center',
          }}
          transition={{
            duration: 0.5,
            delay: i * 0.5 + 2 + initDelay,
          }} // 2 анимация вопроса
        >
          <Variant
            item={item}
            index={i}
            aciveAmimate={isStateCorrectVar && item.correct}
            isStateCorrectVar={isStateCorrectVar}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};
